import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AuthService } from '../../auth.service';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
    selector: 'app-user-edit-dialog',
    templateUrl: './user-edit-dialog.component.html',
    styleUrls: ['./user-edit-dialog.component.scss']
})
export class UserEditDialogComponent implements OnInit {
    editForm: FormGroup;
    hidePassword = true;

    constructor(
        private fb: FormBuilder,
        private authService: AuthService,
        private snackBar: MatSnackBar,
        public dialogRef: MatDialogRef<UserEditDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) {
        this.editForm = this.fb.group({
            name: ['', Validators.required],
            // ▼ 変更
            email: ['', [Validators.required, Validators.email]],
            password: [''],
            authority: ['', Validators.required]
        });
    }

    ngOnInit(): void {
        if (this.data) {
            this.editForm.patchValue({
                name: this.data.name,
                // ▼ 変更
                email: this.data.email,
                authority: this.data.authority
            });
        }
    }

    onSubmit(): void {
        if (this.editForm.invalid) {
            return;
        }

        const updateData = this.editForm.value;
        if (!updateData.password) {
            delete updateData.password;
        }

        this.authService.updateUser(this.data.id, updateData).subscribe({
            next: () => {
                this.snackBar.open('ユーザー情報を更新しました', 'Close', { duration: 3000 });
                this.dialogRef.close(true);
            },
            error: (err) => {
                console.error('Update failed', err);
                const msg = err.error.detail || '更新に失敗しました';
                this.snackBar.open(msg, 'Close', { duration: 3000 });
            }
        });
    }
}